export interface IAcquirer{
  acquirerBin?: string;
}


export class Acquirer implements IAcquirer{
  constructor(
  public acquirerBin?: string
  ) {}
}
